/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { createEntity, getEntity, reset, updateEntity } from './post-op-recovery.reducer';

export const PostOpRecoveryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const nurses = useAppSelector(state => state.nurse.entities);
  const postOpRecoveryEntity = useAppSelector(state => state.postOpRecovery.entity);
  const loading = useAppSelector(state => state.postOpRecovery.loading);
  const updating = useAppSelector(state => state.postOpRecovery.updating);
  const updateSuccess = useAppSelector(state => state.postOpRecovery.updateSuccess);

  const handleClose = () => {
    navigate(`/post-op-recovery${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getNurses({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.recievedAt !== undefined && typeof values.recievedAt !== 'number') {
      values.recievedAt = Number(values.recievedAt);
    }
    if (values.dischargedAt !== undefined && typeof values.dischargedAt !== 'number') {
      values.dischargedAt = Number(values.dischargedAt);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...postOpRecoveryEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      nurse: nurses.find(it => it.id.toString() === values.nurse?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...postOpRecoveryEntity,
          surgery: postOpRecoveryEntity?.surgery?.id,
          nurse: postOpRecoveryEntity?.nurse?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.postOpRecovery.home.createOrEditLabel" data-cy="PostOpRecoveryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.postOpRecovery.home.createOrEditLabel">Create or edit a PostOpRecovery</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="post-op-recovery-id"
                  label={translate('tinyMedicRestApp.postOpRecovery.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.recievedAt')}
                id="post-op-recovery-recievedAt"
                name="recievedAt"
                data-cy="recievedAt"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.carePlan')}
                id="post-op-recovery-carePlan"
                name="carePlan"
                data-cy="carePlan"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.careGiven')}
                id="post-op-recovery-careGiven"
                name="careGiven"
                data-cy="careGiven"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.dischargedAt')}
                id="post-op-recovery-dischargedAt"
                name="dischargedAt"
                data-cy="dischargedAt"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.patientFirst')}
                id="post-op-recovery-patientFirst"
                name="patientFirst"
                data-cy="patientFirst"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.sideRailsUp')}
                id="post-op-recovery-sideRailsUp"
                name="sideRailsUp"
                data-cy="sideRailsUp"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.checkMeds')}
                id="post-op-recovery-checkMeds"
                name="checkMeds"
                data-cy="checkMeds"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.frequentAssessment')}
                id="post-op-recovery-frequentAssessment"
                name="frequentAssessment"
                data-cy="frequentAssessment"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.toiletAssist')}
                id="post-op-recovery-toiletAssist"
                name="toiletAssist"
                data-cy="toiletAssist"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.active')}
                id="post-op-recovery-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.cursor')}
                id="post-op-recovery-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.lastupdated')}
                id="post-op-recovery-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.microSec')}
                id="post-op-recovery-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecovery.timestampentry')}
                id="post-op-recovery-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="post-op-recovery-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.postOpRecovery.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="post-op-recovery-nurse"
                name="nurse"
                data-cy="nurse"
                label={translate('tinyMedicRestApp.postOpRecovery.nurse')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/post-op-recovery" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PostOpRecoveryUpdate;
